export default __webpack_public_path__ + "static/mobile-big-1.5x-6ef9152f8510fde8bde8cf22b4ee4dfe.jpeg";